import React from "react";
import UserDropdown from "./DashboardUserDropdown";
import DoughnutChart from "./payoutOverviewChart";
import LinkSection from "./UserLinks";
import { useSelector } from "react-redux";
import QRCodeDisplay from "./QRCodeDisplay";
import NextRankCriteria from "./NextRankCriteria";

const RightContentSection = ({ props , isMigrate }) => {

  const currency = useSelector((state) => state.user?.selectedCurrency);
  const conversionFactor = useSelector((state) => state.user?.conversionFactor);
  const userSelectedLanguage = useSelector(
    (state) => state.user?.selectedLanguage
  );
  const isAvantgar = props?.isAvantgar
  const productValidity =
    props?.userProfile?.subscriptionDetails?.productValidity
      ?.productValidityDate;

      const replicaLink = props?.replicaLink?.find((link) => link.name === 'Replica Link')

  return (
    <>
      <UserDropdown props={props?.userProfile} />
      {/* <DoughnutChart
        pending={props?.payoutDoughnut?.pending}
        approved={props?.payoutDoughnut?.approved}
        paid={props?.payoutDoughnut?.paid}
        payoutPaid={props?.payoutOverview?.payoutPaid}
        currency={currency}
        conversionFactor={conversionFactor}
        userSelectedLanguage={userSelectedLanguage}
      /> */}
      {new Date(productValidity) > new Date() && !isAvantgar && <QRCodeDisplay replicaLink={replicaLink?.link} />}
      {!isMigrate && !isAvantgar && <LinkSection
        productValidity={productValidity}
        payoutTab={props?.payoutOverview}
        replicaLink={props?.replicaLink}
        leadCaptureLink={props?.leadCaptureLink}
        currency={currency}
        conversionFactor={conversionFactor}
      />}
      <NextRankCriteria data={props?.nextRankCriteria}/>
    </>
  );
};

export default RightContentSection;
